import { render } from "./BlStandaloneField.vue?vue&type=template&id=a372a4ac&scoped=true"
import script from "./BlStandaloneField.vue?vue&type=script&lang=js"
export * from "./BlStandaloneField.vue?vue&type=script&lang=js"

import "./BlStandaloneField.vue?vue&type=style&index=0&id=a372a4ac&scoped=true&lang=scss"

import exportComponent from "/tmp/ef98a231-0263-404c-a747-c31ac6c86af7/frontend/core/frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a372a4ac"]])

export default __exports__